import { paperMaterialBusiness } from "api/bussiness/paper-material/paper-material-bussiness";
import { GetPapersMaterial } from "api/models/request/paper-material/paper-material";
import { Pagination } from "api/models/response/pagination";
import { flow, types } from "mobx-state-tree";
import { withRootStore } from "mobx-stores/_extension/with-root-store";
import {
  IPaperMaterialProperties,
  PaperMaterial,
} from "mobx-stores/_models/paper-inventory/paper-material";
import { withSetPropAction } from "../_extension/with-set-props";
import { PaginationStore } from "./common/pagination-store";
export const PaperMaterialParams = types
  .model({
    code: "",
    type: "",
    gsm: "",
    isExactMatch: true,
  })
  .actions(withSetPropAction);
export const PaperMaterialStore = types
  .model({
    paperMaterials: types.optional(types.array(PaperMaterial), []),
    paperMaterialDetail: types.maybeNull(PaperMaterial),
    pagination: types.optional(PaginationStore, {}),
    openNew: false,
    openEdit: false,
    openDelete: false,
    queryParams: types.optional(PaperMaterialParams, {}),
  })
  .extend(withRootStore)
  .actions(withSetPropAction)
  .actions((self) => ({
    getPapersMaterial: flow(function* getPapersMaterial(
      request?: GetPapersMaterial,
    ) {
      try {
        self._rootStore.setProp("inProgress", true);
        if (!request) {
          request = {
            filter: self.pagination.filter,
            maxResultCount: self.pagination.itemsPerPage,
            skipCount: self.pagination.skipCount,
            sorting: "",
            code: self.queryParams.code,
            gsm: self.queryParams.gsm,
            type: self.queryParams.type,
            isExactMatch: self.queryParams.isExactMatch,
          };
        }
        const res = (yield paperMaterialBusiness.getLists(
          request,
        )) as Pagination<IPaperMaterialProperties>;
        self.setProp("paperMaterials", res.items);
        self.pagination.setProp("totalItems", res.totalCount);
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
  }));
